import CourseModuleVideoDictionary from "@/dictionary/CourseModuleVideoDictionary";
import BaseModel from "./BaseModel";

/**
 * UserCourseVideo 
 */
export default class UserCourseVideo extends BaseModel{

  constructor({
    id,
    course_module_video,
    user,
    status,
    course_module
  }) {
    super();

    this.dictionary = new CourseModuleVideoDictionary();

    this.id = id || null;
    this.course_module_video = course_module_video || null;
    this.user = user || null;
    this.status = status || null;
    this.course_module = course_module || null;
  }

  /**
   * Checks if this UserCourseVideo was watched
   * @returns {boolean}
   */
  isWatched() {
    return this.status == this.dictionary.WATCHED;
  }
}